import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { cleanupOldRooms } from './infrastructure/firebase/FirebaseRoomCleanupService';
import { AuthProvider, useAuth } from './presentation/contexts/AuthContext';
import { ThemeProvider, useTheme } from './presentation/contexts/ThemeContext';
import { LanguageProvider } from './presentation/contexts/LanguageContext';
import { ToastProvider } from './presentation/components/common/Toast';
import { GlobalStyles } from './presentation/styles/GlobalStyles';
import { getTokens } from './presentation/styles/tokens';
import { HomePage } from './presentation/components/home/HomePage';
import { LobbyPage } from './presentation/components/lobby/LobbyPage';
import { GameRoom } from './presentation/components/game/GameRoom';
import { Loader } from './presentation/components/common/Loader';
import { FallingCards } from './presentation/components/common/FallingCards';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  const { theme } = useTheme();
  const t = getTokens(theme);

  if (loading) return <Loader tokens={t} fullPage />;
  if (!user) return <Navigate to="/" replace />;
  return <>{children}</>;
};

const AppContent: React.FC = () => {
  const { theme } = useTheme();
  const t = getTokens(theme);

  useEffect(() => { cleanupOldRooms(); }, []);

  return (
    <>
      <GlobalStyles tokens={t} />
      <FallingCards />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/lobby" element={
            <ProtectedRoute><LobbyPage /></ProtectedRoute>
          } />
          <Route path="/room/:roomId" element={<GameRoom />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

const App: React.FC = () => (
  <LanguageProvider>
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <AppContent />
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  </LanguageProvider>
);

export default App;
